import { useLocation } from "react-router";
import {
  isPendingReview,
  useAssignedReviews,
} from "../../../../../pages/reviews/hooks/use-reviews";

export function usePendingReviewCount(enabled: boolean): number {
  const location = useLocation();

  const { data } = useAssignedReviews(enabled, location);

  return (data ?? []).filter(isPendingReview).length;
}
